import { Injectable } from '@angular/core';
import * as htmlToImage from 'html-to-image';
@Injectable({
    providedIn: 'root',
})
export class ExportService {

    constructor() { }

    private excludedSelectors = ['.exclude-from-export', '.export-loading-overlay','#notifications'];

    private showOverlay(overlayText: string): HTMLElement {
        const overlay = document.createElement('div');
        overlay.id = 'export-overlay';
        overlay.className = 'export-loading-overlay exclude-from-export';
        overlay.innerHTML = `
            <div class="export-loading-content">
                <div class="export-loading-spinner"></div>
                <p class="export-loading-text">${overlayText}</p>
            </div>
        `;
        document.body.appendChild(overlay);
        return overlay;
    }

    private hideElementsForExport() {
        document.querySelectorAll('.hide-in-print').forEach(el => el.classList.add('dis-none'));
    }
    private prepareForExport() {
        document.documentElement.classList.add('export-view'); // Adds to <html>
    }

    private restoreElementsAfterExport() {
        document.querySelectorAll('.hide-in-print').forEach(el => el.classList.remove('dis-none'));
        document.documentElement.classList.remove('export-view'); // Removes from <html>
        // Remove overlay
        const overlay = document.getElementById('export-overlay');
        if (overlay) {
            overlay.remove();
        }
    }

    exportPageAsPng(fileName: string = 'export.png', selector: string = 'body', overlayText: string = 'Generating Page Image...'): Promise<void> {
        const node = document.querySelector(selector) as HTMLElement;

        if (!node) {
            return Promise.reject(`Element not found for selector: ${selector}`);
        }

        // Show overlay immediately - no delay
        this.showOverlay(overlayText);

        this.prepareForExport();
        
        // Force a synchronous DOM update to ensure overlay is visible
        document.body.offsetHeight; // Force reflow

        // Small delay to ensure overlay is painted, then proceed
        return new Promise<void>((resolve, reject) => {
            setTimeout(() => {
                this.hideElementsForExport();

                htmlToImage.toPng(node, {
                    backgroundColor: '#ffffff',
                    skipFonts: true,
                    style: {
                        backgroundColor: '#ffffff',
                    },
                    imagePlaceholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQI12NgAAIABQABNjN9GQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAA0lEQVQI12P4z8BQDwAEgAF/QualzQAAAABJRU5ErkJggg==',
                    filter: (el: HTMLElement) => {
                        if (!(el instanceof Element)) {
                            return true;
                        }
                        
                        if (el.classList){
                            // && (el.classList.contains('exclude-from-export') || 
                            //                             el.classList.contains('export-loading-overlay'))) {
                            //                             return false;
                             this.excludedSelectors.forEach(selector => {
                                const selectorType = selector.startsWith('.') ? 'class' : selector.startsWith('#') ? 'id' : null;

                                if (selectorType === 'class' && el.classList.contains(selector.replace('.', ''))) {
                                    return false;
                                } else if (selectorType === 'id' && el.id === selector.replace('#', '')) {
                                    return false;
                                }
                             });
                        } 
                        
                        
                        if (el.tagName === 'LINK' && (el as HTMLLinkElement).rel === 'stylesheet') {
                            const href = (el as HTMLLinkElement).href;
                            if (href && !href.startsWith(window.location.origin)) {
                                return false;
                            }
                        }
                        if (el.tagName === 'IMG') {
                            const src = (el as HTMLImageElement).src;
                            if (src && !src.startsWith('data:') && !src.startsWith(window.location.origin)) {
                                return false;
                            }
                        }
                        return true;
                    }
                }).then((dataUrl: string) => {
                    if (!dataUrl || dataUrl === 'data:,') {
                        throw new Error('Export produced an empty image.');
                    }
                    const link = document.createElement('a');
                    link.download = fileName;
                    link.href = dataUrl;
                    link.click();
                    link.remove();
                    resolve(); // Only resolve here
                }).catch((err: unknown) => {
                    const message = err instanceof Error ? err.message 
                                : typeof err === 'string' ? err
                                : 'An unknown error occurred while exporting the image.';
                    reject(new Error(message)); // Reject with error
                }).finally(() => {
                    this.restoreElementsAfterExport();
                    // Don't resolve here - already handled in then/catch
                });
            }, 100); // Give overlay time to render
        });
    }
}
